import { Form, Formik } from 'formik'
import React, { useContext, useState } from 'react'
import { PencilSquare } from 'react-bootstrap-icons'
import { InfluencerContext } from '../../../../../contexts/InfluencerContext'
import { InfluencerSchema } from '../../../../../schemas/InfluencerSchema'
import axiosService from '../../../../../utils/AxiosService'
import Input from '../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../FormComponents/Toasts'
import Modal from '../../../../Modal/Modal'

export default function Influencer() {
  const { influencer } = useContext(InfluencerContext)
  const [modalOpen, setModalOpen] = useState(false)

  const updateInfluencer = ({ full_name, email }) => {
    axiosService.patch(`/api/project_manager/influencers/${influencer.id}`, { influencer: { full_name, email } })
    .then((updatedInfluencer) => {
      influencer.full_name = updatedInfluencer.full_name
      influencer.email = updatedInfluencer.email
      toastSuccess('Influencer updated')
      setModalOpen(false)
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-xl">
      <div className="flex justify-between">
        <p className="font-bold text-xl mb-4 dark:text-white">Influencer</p>
        <button onClick={() => setModalOpen(true)} className="flex items-center text-sm font-bold ml-4 dark:text-white"><PencilSquare /> Edit</button>
      </div>
      <div>
        <div className="flex items-center justify-between">
          <p className="dark:text-white">Full Name:</p>
          <p className="font-bold dark:text-white">{influencer.full_name}</p>
        </div>
        <div className="flex items-center justify-between">
          <p className="dark:text-white">Email:</p>
          <p className="font-bold dark:text-white">{influencer.email}</p>
        </div>
      </div>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <Modal.Header>Update Influencer</Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={InfluencerSchema}
            initialValues={{
              full_name: influencer.full_name,
              email: influencer.email
            }}
            onSubmit={updateInfluencer}
          >
            {({ handleBlur, handleChange, values, errors, touched }) => (
              <Form>
                <div className="form-item-container w-full">
                  <Input error={touched.full_name && errors.full_name} label="Full Name" name='full_name' onChange={handleChange} onBlur={handleBlur} value={values.full_name} />
                  <Input error={touched.email && errors.email} label="Email" name='email' onChange={handleChange} onBlur={handleBlur} value={values.email} />
                  <button
                    type="submit"
                    className="submit text-left w-full text-rb-green border-2 rounded-full w-60 py-4 text-center active:shadow-outer active:shadow-rb-green border-rb-green"
                  >
                    Update Influencer
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  )
}